import { enableProdMode } from "@angular/core";
import { platformBrowser } from "@angular/platform-browser";
import { provideAgGrid } from "@design-factory/design-factory";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule, {
    applicationProviders: [provideAgGrid()],
  })
  .catch((err) => console.log(err));
